<template>
    <div class="avatar avatar-l no-flex inline-m">
        <div class="avatar-image" v-fs-block>
            <figure class="image image-avatar">
                <img :alt="integration.displayLabel" :src="integration.logoSrc"/>
            </figure>
        </div>
    </div>
</template>

<script>
    import IntegrationModel from '@/common/models/integration-model';

    export default {
        props: {
            integration: {
                type: IntegrationModel,
                required: true,
            },
        },
    };
</script>
